/**
 * Store state for wordpress/media module
 */
export const initialState = {
  media: []
}

const state = {...initialState}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/media/state.js